import './pdf-viewer.scss'

import { faSearch, faSearchMinus, faSearchPlus, faTimes } from '@fortawesome/free-solid-svg-icons';
import { get } from 'lodash'
import * as PDFJS from 'pdfjs-dist'
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';

import { ReactiveVue } from '@skinsoft/reactive-vue';

import { PDFProgressBar } from '../../../../../apps/condition-report/src/app/pdf-overview-screen/pdf-progress-bar';
import { PDFViewerPage } from './pdf-viewer-page';
import { DISPLAY_ALERT_TOPIC } from '@skinsoft/bus/src/busTopics';

@Component({
    components: {
        sPdfProgressBar: PDFProgressBar,
        sPdfViewerPage: PDFViewerPage,
    },
    props: ['pdfFile'],
    template: require('./pdf-viewer.html')
})
export class PDFViewer extends ReactiveVue {

    public pdfFile: File;
    public pdf: File;
    public magnifierIcon = faSearch;
    public magnifierPlusIcon = faSearchPlus;
    public magnifierMinusIcon = faSearchMinus;
    public crossIcon = faTimes;

    public $refs: {
        pdfCanvasPrev: HTMLCanvasElement
        pdfCanvasCurrent: HTMLCanvasElement
        pdfCanvasNext: HTMLCanvasElement
        pageScrollContainer: HTMLDivElement
    }

    private pdfData = null as any;
    private zoomPageScale: number = 1.3;
    private readonly ZOOM_FACTOR: number = 0.05;

    private currentPageIndex: number = 1;
    private displayZoomOverlay: boolean = false;
    private pagesIndices: number[] = [];
    private nbPdfPages: number = 0;

    public get pdfCanvasPrev() {
        return this.$refs.pdfCanvasPrev
    }

    public get pdfCanvasCurrent() {
        return this.$refs.pdfCanvasCurrent
    }

    public get pdfCanvasNext() {
        return this.$refs.pdfCanvasNext
    }

    public get pageScrollContainer() {
        return this.$refs.pageScrollContainer;
    }

    private onPDFFile(pdfData) {
        this.renderPDF(pdfData)
    }

    private renderPDF(pdfData) {
        PDFJS.getDocument(pdfData).promise.then((pdf) => {
            this.nbPdfPages = pdf.numPages
            this.pdf = pdf;
            for (let i = 1; i <= this.nbPdfPages; i++) {
                this.pagesIndices.push(i);
            }
        }, (reason) => {
            // PDF loading error
            console.error(reason);
            const alertPayload = {
                message: this.$t('pdfOverviewScreen.renderFailureAlert'),
                variant: 'danger'
            };
            this.emitOnBus(DISPLAY_ALERT_TOPIC, alertPayload)
        });
    }

    private onViewerScroll(event) {
        const scrollElement = event.target
        const scrollLimit = scrollElement.scrollWidth - scrollElement.clientWidth;
        const scrollRatio = scrollElement.scrollLeft / scrollLimit;
        this.currentPageIndex = this.clampValue(Math.floor(scrollRatio * this.nbPdfPages) + 1, 1, this.nbPdfPages)
    }

    private clampValue(value, min, max) {
        return Math.max(min, Math.min(max, value))
    }

    private displayZoomView() {
        this.displayZoomOverlay = true;
    }

    private onZoomCrossClick() {
        this.displayZoomOverlay = false;
    }

    private zoomIn() {
        this.zoomFromDelta(1)
    }

    private zoomOut() {
        this.zoomFromDelta(-1);
    }

    private zoomFromDelta(delta) {
        let newScale: number;
        if (delta > 0) {
            newScale = this.zoomPageScale + this.ZOOM_FACTOR;
        } else {
            newScale = this.zoomPageScale - this.ZOOM_FACTOR;
        }
        this.zoomPageScale = this.clampValue(newScale, 0, 3)
    }

    @Watch('pdfFile', { immediate: true })
    private onPDFFileChange(pdfFile) {
        const reader = new FileReader();
        reader.addEventListener("load", (inputElement) => {
            const result = get(inputElement, "srcElement.result");
            if (result) {
                this.pdfData = new Uint8Array(result);
                this.onPDFFile(this.pdfData);
            }
        })
        reader.readAsArrayBuffer(pdfFile)
    }

}